type ForceLogoutFn = () => void;

let forceLogoutImpl: ForceLogoutFn | null = null;

// Conectado una sola vez por AuthProvider (ver hooks/useAuth.tsx) — permite
// que lib/api.ts, al interceptar un 403 CUENTA_INACTIVA, limpie también el
// estado de React (no solo el módulo de storage) para que useAuth().user
// deje de reflejar al usuario ya inválido de inmediato.
export function setForceLogout(fn: ForceLogoutFn): void {
  forceLogoutImpl = fn;
}

export function forceLogout(): void {
  forceLogoutImpl?.();
}
